import { FC, ReactNode } from 'react';

import { IconName, Size } from '@purpur/library/icon';

import { getSvgIcon } from '@telialt/common-icon/src';

import { getSupportedColor } from './getSupportedColor';
import { StyledIcon, Text, TextButtonWithIconColored } from './VasButton.styles';

type ReadOnly = { readOnly: true; onClick?: undefined };
type Pressable = { readOnly?: false; onClick: () => void; dataTest?: string };
type OwnProps = { icon: IconName | string; iconSize?: Size; iconColor?: string; children: ReactNode };

const TextWithIconColored: FC<OwnProps> = ({ icon, iconSize, children, iconColor }) => {
    const iconsSvg = getSvgIcon(icon);

    return (
        <Text $iconColor={iconColor}>
            <StyledIcon svg={iconsSvg} size={iconSize} />
            {children}
        </Text>
    );
};

export const VasButton: FC<OwnProps & (Pressable | ReadOnly)> = ({
    readOnly,
    onClick,
    iconColor,
    iconSize = 'md',
    ...props
}) => {
    const colorCode = getSupportedColor(iconColor);

    if (readOnly) {
        return <TextWithIconColored {...props} iconSize={iconSize} iconColor={colorCode} />;
    }

    return <TextButtonWithIconColored {...props} $iconColor={colorCode} iconSize={iconSize} onClick={onClick} />;
};
